import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import { useDCContext } from "@src/context";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

import { ImageWithRetry } from "../atoms";

const OverviewHeader = (props) => {
  const { greeting = "", dataMessage, customerCode, industry } = props;
  const { getDynamicReplacement, existsDynamicReplacements } = useDCContext();
  const imgUrl = existsDynamicReplacements(
    `customers__${customerCode.toLowerCase()}__overview_header_img_url`,
  )
    ? getDynamicReplacement(
        `customers__${customerCode.toLowerCase()}__overview_header_img_url`,
      )
    : getDynamicReplacement("captain__overview__header_img_url");

  return (
    <div className="w-full min-h-36 relative overflow-hidden flex">
      <div
        className={`relative p-6 z-40 my-full w-2/3 md:w-1/2 text-white flex flex-col ${"justify-center"}`}
      >
        <span className="text-2xl font-extrabold">{greeting}</span>
        {dataMessage && <span>{dataMessage}</span>}
      </div>
      <div className="absolute top-0 w-full h-full bg-primary-600 opacity-60 z-30" />
      <ImageWithRetry
        src={imgUrl}
        alt=""
        className={`absolute z-20 max-w-2xl ${
          industry === "shipping"
            ? "animate-slideInLeftSubtle"
            : "animate-slideInRightSubtle"
        }`}
        style={{
          top: 0,
          left: "60%",
          height: "98%",
        }}
      />
      <ImageWithRetry
        src="https://signol-email-images.s3.eu-west-2.amazonaws.com/overview_page_header_swirl.svg"
        alt=""
        className="absolute z-10 w-full max-w-3xl opacity-80 left-0 bottom-[-40%] md:bottom-[-120%]"
      />
    </div>
  );
};

export const OverviewHeaderControls = {
  greeting: {
    propType: PropTypes.node,
    description: "Title",
    disable: true,
  },
  dataMessage: {
    propType: PropTypes.string,
    description: "Subtitle",
    controlType: "text",
  },
  customerCode: COMMON_CONTROLS.customerCode,
  industry: COMMON_CONTROLS.industry,
};

OverviewHeader.propTypes = AppUtils.getPropTypeFromControls(
  OverviewHeaderControls,
);

export default OverviewHeader;
